/**
 * Supported image MIME types for preview and cropping
 */
export const IMAGE_TYPES = [
    'image/png',
    'image/jpeg',
    'image/webp',
    'image/gif',
    'image/bmp',
    'image/heic',
];

/**
 * Supported image file extensions for preview and cropping
 */
export const IMAGE_EXTENSIONS = ['png', 'jpeg', 'jpg', 'webp', 'gif', 'bmp', 'heic'];

/**
 * Default width for file items in the AttachmentList variant
 */
export const FILE_ITEM_WIDTH = 200;

/**
 * Gap between file items in the AttachmentList variant
 */
export const FILE_ITEM_GAP = 8;
